import React, { useState, useEffect, useRef } from 'react';
import TablaUsuarios from './Tabla/TablaClientes';
import Exportar from './Botones/Exportar';
import EliminarUno from './Dialogos/EliminarUno';
import EliminarVarios from './Dialogos/EliminarVarios';
import CrearModificar from './Dialogos/CrearModificar';
import { leftToolbarTemplate } from '../ComponentsCat/Botones/AgregarEliminar'
import { clienteVacio } from './Objetos/ClienteVacio';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Service } from '../../../service/Service';
import Spinner from '../../../components/loader/Spinner';
import ErrorSistema from '../../../components/error/ErrorSistema';
import { CLIENTE, LICENCIAS_CLIENTE, LICENCIAS_CLIENTES_DASHBOARD } from '../../../genericos/Uris';
import Licencias from './Licencias/Licencias';
import { useHistory } from 'react-router-dom';

import Environment from '../../../Environment'
const getRoute = Environment();

const CrudClientes = ({ titulos, notificaciones }) => {
    //--------------------| Inicializacion |--------------------
    const clienteService = new Service()
    clienteService.baseUrl = `${getRoute}/${CLIENTE}`

    //--------------------| Uso de estados |--------------------
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState(clienteVacio);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [tieneId, setTieneId] = useState(false)
    //--> Estilos de inputs
    const [estiloNombre, setEstiloNombre] = useState("");
    const [estiloApellido, setEstiloApellido] = useState("");
    const [estiloPersona, setEstiloPersona] = useState("");
    const [estiloRazonSocial, setEstiloRazonSocial] = useState("");
    const [estiloRfc, setEstiloRfc] = useState("");
    const [estiloEmail, setEstiloEmail] = useState("");

    const [estiloCalle, setEstiloCalle] = useState("");
    const [estiloNumInt, setEstiloNumeroInt] = useState("");
    const [estiloNumExt, setEstiloNumeroExt] = useState("");
    const [estiloColonia, setEstiloColonia] = useState("");
    const [estiloCp, setEstiloCp] = useState("");
    const [estiloDelegacionMunicipio, setEstiloDelegacionMunicipio] = useState("");
    const [estiloCiudad, setEstiloCiudad] = useState("");
    const [idCliente, setIdCliente] = useState();


    //--> Interaccion con back-end
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    const toast = useRef(null);
    const dt = useRef(null);

    //--------------------| Funciones de Crud |--------------------
    //--> Crear nuevo producto

    const createProduct = async (product) => {
        setIsLoading(true)
        setError(null)
        try {
            await clienteService.create(product)
            const data = await clienteService.readAll()
            setProducts(data)
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.creacion}`, life: 3000 });
    }

    const updateProduct = async (product) => {
        setIsLoading(true)
        setError(null)
        try {
            clienteService.baseUrl = `${getRoute}/${CLIENTE}/${product.id}`;
            await clienteService.update(product);
            clienteService.baseUrl = `${getRoute}/${CLIENTE}`;
            const data = await clienteService.readAll();
            setProducts(data)
        } catch (error) {
            setError(error.message)
        }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.modificacion}`, life: 3000 });
    }

    const deleteProduct = async (id) => {
        setIsLoading(true)
        setError(null)
        try {
            await clienteService.delete(id)
            const data = await clienteService.readAll()
            setProducts(data)
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.eliminacion}`, life: 3000 });
    }


    //--------------------| Dialogos |--------------------
    //--> Nuevo gasto
    const openNew = () => {
        setProduct(clienteVacio);
        setProductDialog(true);
        setEstiloNombre("")
        setEstiloApellido("")
        setEstiloPersona("")
        setEstiloRazonSocial("")
        setEstiloRfc("")
        setEstiloEmail("")
    }
    //--> Ocultar dialogo crear
    const hideDialog = () => { setProductDialog(false) }
    //--> Ocultar dialogo de eliminar 1 producto
    const hideDeleteProductDialog = () => { setDeleteProductDialog(false) }
    //--> Ocultar dialogo de eliminar varios productos
    const hideDeleteProductsDialog = () => { setDeleteProductsDialog(false) }
    //--> Eliminar 1 producto
    const [productToDel, setProductToDel] = useState({});
    const confirmDeleteProduct = (product) => {
        setProductToDel(product);
        setDeleteProductDialog(true);
    }
    //--> Eliminar varios productos
    const confirmDeleteSelected = () => { setDeleteProductsDialog(true) }

    //--------------------| Acciones de crud |--------------------
    //------> Actualizar campo de producto
    const updateField = (data, field) => {
        setProduct({
            ...product,
            [field]: data,
        });
    };
    //------> Agregar nuevo registro
    const saveProduct = () => {
        if (!product.id) { createProduct(product) }
        else { updateProduct(product) }
        setProduct(clienteVacio);
        setProductDialog(false);
    }
    //------> Eliminar 1 producto
    const _deleteProduct = () => {
        deleteProduct(product.id)
        setProduct(clienteVacio)
        setDeleteProductDialog(false)
    }
    //------> Eliminar varios productos
    const deleteSelectedProducts = async () => {
        selectedProducts.forEach(registro => deleteProduct(registro.idCliente))
        const respuesta = await clienteService.readAll()
        setProducts(respuesta)


        setDeleteProductsDialog(false);                                         // Ocultara dialogo
        setSelectedProducts(null);                                              // Elemetos seleccionados = 0
    }
    //------> Editar producto
    const [hideInputs, setHideInputs] = useState(true);
    const _editProduct = async (product) => {
        try {
            setProductDialog(true);
            setLoadingButton(true)
            clienteService.baseUrl = `${getRoute}/${CLIENTE}`;
            const data = await clienteService.findById(product.idCliente);
            setProduct(data);
            setProductDialog(true);
        } catch (e) {
            console.log(e);
        }
        setLoadingButton(false)
    }
    const licenciaService = new Service();
    const [licenciaCliente, setLicenciaCliente] = useState({});
    const [dialogLicencia, setDialogLicencia] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    // Edita el registro de licencia
    const licencia = async (cliente) => {
        console.log("Editando licencia");
        licenciaService.baseUrl = `${getRoute}/${LICENCIAS_CLIENTE}`
        try {
            setDialogLicencia(true);
            setLoading(true);

            const data = await licenciaService.findById(cliente.idCliente);
            setIdCliente(cliente.idCliente);

            setLoading(false);
            setLicenciaCliente(data);
        } catch (e) {
            if (e.response.data === "El sistema no encontro información del registro.") history.push(`/${LICENCIAS_CLIENTES_DASHBOARD}/${cliente.idCliente}`);
            setLoading(false);
        }
    }


    const [loadingButton, setLoadingButton] = useState(false);
    //--------------------| Botones en pantalla |--------------------
    //------> Botones para agregar/eliminar productos
    const BotonesCabezal = leftToolbarTemplate(openNew, confirmDeleteSelected, selectedProducts);

    //------> Boton para exportar
    const ExportarRegistros = Exportar(products);

    //------> Botones parte derecha
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => _editProduct(rowData)} />
                <Button icon="pi pi-id-card" className="p-button-rounded p-button-info" onClick={() => licencia(rowData)} />
            </>
        );
    }

    //--------------------| Obtener registros de back-end |--------------------
    //---> Obtendra los datos del back-end
    useEffect(() => {
        const cargarDatos = async () => {
            setIsLoading(true)
            setError(null)
            try {
                const data = await clienteService.readAll()
                setProducts(data)
            } catch (error) {
                setError(error.message)
            }
            setIsLoading(false)
        }
        cargarDatos()
        return () => {                                      // Funcion de limpieza
            setProducts([])
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps    

    //--------------------| Abilitar o inhabilitar boton |--------------------
    useEffect(() => {
        // Edicion
        if (product.id) {
            setHideInputs(false)
            setTieneId(false)
        }
        // Creacion
        else {
            // setHideInputs(true)
            setTieneId(true)
        }
    }, [product])

    const notificacionCrearLicencia = () => {
        toast.current.show({ severity: 'success', summary: '¡Atención!', detail: 'La licencia se modifico correctamente', life: 3000 });
    }

    //--------------------| Valor que regresara |--------------------
    return (
        <div className="datatable-crud-demo">
            <Toast ref={toast} />
            {!isLoading && !error && (
                <TablaUsuarios
                    BotonesCabezal={BotonesCabezal}
                    ExportarRegistros={ExportarRegistros}
                    dt={dt}
                    products={products}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    actionBodyTemplate={actionBodyTemplate}
                    openNew={openNew}
                    confirmDeleteSelected={confirmDeleteSelected}
                />
            )}
            {isLoading && <Spinner />}
            {error && <ErrorSistema texto={error} />}

            <CrearModificar
                productDialog={productDialog}
                setLoadingButton={setLoadingButton}
                loadingButton={loadingButton}
                titulos={titulos}
                saveProduct={saveProduct}
                hideDialog={hideDialog}
                product={product}
                updateField={updateField}
                tieneId={tieneId}
                estiloNombre={estiloNombre} setEstiloNombre={setEstiloNombre}
                estiloApellido={estiloApellido} setEstiloApellido={setEstiloApellido}
                estiloPersona={estiloPersona} setEstiloPersona={setEstiloPersona}
                estiloRazonSocial={estiloRazonSocial} setEstiloRazonSocial={setEstiloRazonSocial}
                estiloRfc={estiloRfc} setEstiloRfc={setEstiloRfc}
                estiloEmail={estiloEmail} setEstiloEmail={setEstiloEmail}
                estiloCalle={estiloCalle} setEstiloCalle={setEstiloCalle}
                estiloNumeroInt={estiloNumInt} setEstiloNumeroInt={setEstiloNumeroInt}
                estiloNumeroExt={estiloNumExt} setEstiloNumeroExt={setEstiloNumeroExt}
                estiloColonia={estiloColonia} setEstiloColonia={setEstiloColonia}
                estiloCp={estiloCp} setEstiloCp={setEstiloCp}
                estiloDelegacionMunicipio={estiloDelegacionMunicipio} setEstiloDelegacionMunicipio={setEstiloDelegacionMunicipio}
                estiloCiudad={estiloCiudad} setEstiloCiudad={setEstiloCiudad}
                notificaciones={notificaciones}
                setIsLoading={setIsLoading}
                setError={setError}
                setProduct={setProduct}
                setProducts={setProducts}
                updateProduct={updateProduct}
                clienteVacio={clienteVacio}
                setProductDialog={setProductDialog}
                hideInputs={hideInputs} setHideInputs={setHideInputs}
            />

            <EliminarUno
                deleteProductDialog={deleteProductDialog}
                _deleteProduct={_deleteProduct}
                hideDeleteProductDialog={hideDeleteProductDialog}
                product={productToDel}
            />

            <EliminarVarios
                deleteProductsDialog={deleteProductsDialog}
                deleteSelectedProducts={deleteSelectedProducts}
                hideDeleteProductsDialog={hideDeleteProductsDialog}
                product={productToDel}
            />

            <Licencias
                licenciaCliente={licenciaCliente}
                setLicenciaCliente={setLicenciaCliente}
                dialogLicencia={dialogLicencia}
                loading={loading}
                setLoading={setLoading}
                setDialogLicencia={setDialogLicencia}
                idCliente={idCliente}
                setProducts={setProducts}
                notificacionCrearLicencia={notificacionCrearLicencia}
            />

        </div>
    );
}

export default CrudClientes;